import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const StatisticheConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/statistiche/appuntamenti_questionari',
      component: FuseLoadable({
        loader: () => import('./ListaAppuntamenti')
      })
    },
    {
      path: '/statistiche/incassi',
      component: FuseLoadable({
        loader: () => import('./ListaTransazioniEmesse')
      })
    },
    {
      path: '/statistiche/autorizzazioni',
      component: FuseLoadable({
        loader: () => import('./ListaAutorizzazioni')
      })
    },
    {
      path: '/statistiche/rinnoviNew',
      component: FuseLoadable({
        loader: () => import('./ListaRinnoviNew')
      })
    },
    {
      path: '/statistiche/frazionamenti',
      component: FuseLoadable({
        loader: () => import('./ListaFrazionamenti')
      })
    },
    {
      path: '/statistiche/new_business',
      component: FuseLoadable({
        loader: () => import('./ListaNewBusiness')
      })
    },
    {
      path: '/statistiche/marketing',
      component: FuseLoadable({
        loader: () => import('./ListaMarketing')
      })
    },
    {
      path: '/statistiche/richiesteUniche',
      component: FuseLoadable({
        loader: () => import('./ListaRichiesteUniche')
      })
    },
    {
      path: '/statistiche/scadenze',
      component: FuseLoadable({
        loader: () => import('./ListaScadenze')
      })
    },
    {
      path: '/statistiche/polizze_esterne',
      component: FuseLoadable({
        loader: () => import('./ListaPolizzeEsterne')
      })
    },
    {
      path: '/statistiche/utenti',
      component: FuseLoadable({
        loader: () => import('./ListaUtenti')
      })
    },
    {
      path: '/statistiche/relazioni',
      component: FuseLoadable({
        loader: () => import('./ListaRelazioni')
      })
    },
    {
      path: '/statistiche/recall',
      component: FuseLoadable({
        loader: () => import('./ListaRecall')
      })
    },
    {
      path: '/statistiche/utm',
      component: FuseLoadable({
        loader: () => import('./ListaUtm')
      })
    },
    {
      path: '/statistiche/tasks',
      component: FuseLoadable({
        loader: () => import('./ListaTasks')
      })
    },
    {
      path: '/statistiche/operatori',
      component: FuseLoadable({
        loader: () => import('./GestioneOperatori')
      })
    },
    {
      path: '/statistiche/analisi',
      component: FuseLoadable({
        loader: () => import('./AnalisiGestione')
      })
    }
  ]
}
